const TWO_FACTOR_BALANCE_ERROR_CODE = "2FA_REQUIRED_DUE_TO_BALANCE";
const TWO_FACTOR_BALANCE_STORAGE_KEY = "twoFactorBalanceEnforced";
const TWO_FACTOR_BALANCE_RETURN_URL_KEY = "twoFactorBalanceReturnUrl";
const TWO_FACTOR_BALANCE_PROFILE_SLUG_KEY = "twoFactorBalanceProfileSlug";

const getProfileSlugFromPath = (): string => {
  if (typeof window === "undefined") {
    return "";
  }

  const profileSlugMatch =
    window.location.pathname.match(/^\/profile\/([^/]+)/);
  return profileSlugMatch?.[1] ?? "";
};

export const getTwoFactorBalanceSecurityUrl = (): string => {
  const pathSlug = getProfileSlugFromPath();

  if (pathSlug) {
    setTwoFactorBalanceProfileSlug(pathSlug);
  }

  const storedSlug = getTwoFactorBalanceProfileSlug();
  const profileSlug = pathSlug || storedSlug || "";

  return profileSlug
    ? `/profile/${profileSlug}/account?tab=security`
    : "/profile/account?tab=security";
};

export const setTwoFactorBalanceProfileSlug = (slug: string): void => {
  if (typeof window === "undefined" || !slug) {
    return;
  }

  window.sessionStorage.setItem(TWO_FACTOR_BALANCE_PROFILE_SLUG_KEY, slug);
};

export const getTwoFactorBalanceProfileSlug = (): string => {
  if (typeof window === "undefined") {
    return "";
  }

  return (
    window.sessionStorage.getItem(TWO_FACTOR_BALANCE_PROFILE_SLUG_KEY) || ""
  );
};

export const isTwoFactorBalanceError = (error: any): boolean => {
  return (
    error?.response?.status === 403 &&
    error?.response?.data?.error_code === TWO_FACTOR_BALANCE_ERROR_CODE
  );
};

export const persistTwoFactorBalanceEnforcedState = (
  returnUrl?: string,
): void => {
  if (typeof window === "undefined") {
    return;
  }

  window.sessionStorage.setItem(TWO_FACTOR_BALANCE_STORAGE_KEY, "true");

  if (returnUrl) {
    window.sessionStorage.setItem(TWO_FACTOR_BALANCE_RETURN_URL_KEY, returnUrl);
  }
};

export const isTwoFactorBalanceEnforcedStatePersisted = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  return (
    window.sessionStorage.getItem(TWO_FACTOR_BALANCE_STORAGE_KEY) === "true"
  );
};

export const popTwoFactorBalanceReturnUrl = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }

  const returnUrl = window.sessionStorage.getItem(
    TWO_FACTOR_BALANCE_RETURN_URL_KEY,
  );

  if (returnUrl) {
    window.sessionStorage.removeItem(TWO_FACTOR_BALANCE_RETURN_URL_KEY);
  }

  return returnUrl;
};

export const clearTwoFactorBalanceEnforcedState = (): void => {
  if (typeof window === "undefined") {
    return;
  }

  window.sessionStorage.removeItem(TWO_FACTOR_BALANCE_STORAGE_KEY);
  window.sessionStorage.removeItem(TWO_FACTOR_BALANCE_RETURN_URL_KEY);
  window.sessionStorage.removeItem(TWO_FACTOR_BALANCE_PROFILE_SLUG_KEY);
};

export const redirectToTwoFactorBalanceSecurity = (
  returnUrl?: string,
): void => {
  if (typeof window === "undefined") {
    return;
  }

  const securityUrl = getTwoFactorBalanceSecurityUrl();
  const currentUrl = `${window.location.pathname}${window.location.search}`;

  if (returnUrl && returnUrl !== securityUrl) {
    persistTwoFactorBalanceEnforcedState(returnUrl);
  } else if (currentUrl !== securityUrl) {
    persistTwoFactorBalanceEnforcedState(currentUrl);
  } else {
    persistTwoFactorBalanceEnforcedState();
  }

  if (currentUrl === securityUrl) {
    return;
  }

  window.location.assign(securityUrl);
};
